

const NO_SESSION_URLS = [
  "/login",
  "/forget-password"];

const ALL_USER_ACCESSIBLE_URLS = [
  "/profile"];

const ONLY_ADMIN_ACCESSIBLE_URLS = [
  "/admin/dashboard",
  "/admin/organizations",
  "/admin/users"];

const ONLY_USER_ACCESSIBLE_URLS = [
  "/user/dashboard",
  "/user/myserviceunits"];


// Set Local Storage Item
export function setLocalStorage(item,value){
  localStorage.setItem(item,value)
  return true
}

// Get Local Storage
export function getLocalStorage(item){
  return localStorage.getItem(item)
}

// Get Local Storage
export function removeLocalStorage(item){
  return localStorage.removeItem(item)
}

// Check whether User Logged in or Not
export function isUserLogged() {
  let session_key_get = getLocalStorage('session_key')
  if (session_key_get != null && session_key_get != '') {
    return true
  } else {
    return false
  }
}
